// const GET_MEAL_BY_MEAL_ID_URL: string = AMBROSIA_API_PREFIX + "/meal/$mealId";
// const GET_USER_MEAL_PLAN_URL: string = AMBROSIA_API_PREFIX + "/userMealPlan/$patientId";
// const GET_CREATE_MEAL_URL: string = AMBROSIA_API_PREFIX + "/meal";
// const GET_DISHES_BY_NAME_URL: string = AMBROSIA_API_PREFIX + "/user/dish/search?q=";
// const GET_ADD_TEMPLATE_URL: string = AMBROSIA_API_PREFIX + "/mealTemplates";
// const GET_SAVE_USER_MEAL_PLAN_URL: string = AMBROSIA_API_PREFIX + "/userMealPlan";
// const FETCH_USER_MEAL_PLAN_ALLOWANCE_URL: string = AMBROSIA_API_PREFIX + "/userMealPlan/TEE/$patientId";
// const GET_DIET_PLAN_TAGS_URL: string = AMBROSIA_API_PREFIX + "/masterData/tags/getAll";
// const GET_DIET_PLAN_TEMPLATE_SEARCH: string = AMBROSIA_API_PREFIX + "/mealTemplates/filter";
// const GET_DELETE_MEAL_TEMPLATE_URL: string = AMBROSIA_API_PREFIX + "/mealTemplates/?id=$templateId";
// const GET_DISH_BY_DISH_IDS_URL: string = AMBROSIA_API_PREFIX + "/dish/bulkFetch";
// const LOG_CUSTOM_MEDICINE_URL: string = AMBROSIA_API_PREFIX + "/medicine/";
// const LOG_CUSTOM_DISH_URL: string = AMBROSIA_API_PREFIX + "/dish";
// const SEARCH_MEDICINE: string = AMBROSIA_API_PREFIX + "/medicine/search?q=$query";
// const FETCH_MEAL_BY_MEAL_ID_URL: string = AMBROSIA_API_PREFIX + "/meal/$mealId/detail";
// const GET_DISH_NUTRITION_PROFILE_URL: string = AMBROSIA_API_PREFIX + "/dish/nutritionProfile";
// const FETCH_DISH_RECOMMENDATION_URL: string = AMBROSIA_API_PREFIX + "/coach/dish/recommendation";
// const GET_PATIENT_ACTIVITY_LOGGING_URL: string = AMBROSIA_API_PREFIX + "/patientActivity/filter";
// const GET_MEAL_ACTIVITY_LOG_FOR_DATE_RANGE_URL: string = AMBROSIA_API_PREFIX + "/mealActivityLog/filter";
// const GET_NUTRITION_INSIGHTS_FOR_DATE_RANGE_URL: string = AMBROSIA_API_PREFIX + "/mealActivity/nutritionInsights";
// const GET_TOP_CONTRIBUTOR_BY_DATE_URL: string = AMBROSIA_API_PREFIX + "/mealActivity/topContribution?date=$date&nutritionType=$nutritionType&userId=$userId";
// const FETCH_ACTIVITY_LOG_FOR_ACTIVITY_TYPE: string = AMBROSIA_API_PREFIX + "/activityLog/filterAll";
// const FETCH_DIET_PLAN_REMINDER_STATUS: string = AMBROSIA_API_PREFIX + "/dietNotification/status?userId=$userId";
// const UPDATE_DIET_PLAN_REMINDER: string = AMBROSIA_API_PREFIX + "/dietNotification/update/notification";
// const FETCH_FITNESS_ACTIVITY_LOG_FOR_FILTER: string = AMBROSIA_API_PREFIX + "/fitnessActivityLog/filter";
// const TRIGGER_MEAL_PLAN_PDF: string = AMBROSIA_API_PREFIX + "/dailyUserMealPlan/send/pdf/whatsapp/$patientId?appTenant=$tenant";
// const FETCH_STATIC_CUISINES: string = AMBROSIA_API_PREFIX + "/masterData/cuisines/nux";
// const UPDATE_USER_PURCHASE_RECOMMENDATIONS: string = AMBROSIA_API_PREFIX + "/userPurchaseRecommendations/";
// const getUserPurchaseRecommendationsUrl = (userId: string): string => AMBROSIA_API_PREFIX + `/userPurchaseRecommendations/detailed?userId=${userId}`;
// const GET_ALL_FITNESS_PLANS: string = AMBROSIA_API_PREFIX + "/plan/all";
// const START_FITNESS_AND_MINDFULNESS_PLAN = AMBROSIA_API_PREFIX + `/plan/start`;
// const GET_USER_FITNESS_AND_MINDFULLNESS_LEVEL = AMBROSIA_API_PREFIX + "/plan/userLevel";
// const GET_USER_PROGRESS_SUMMARY = AMBROSIA_API_PREFIX + "/user-progress/summary";
// experiments
// const experimentsUrl = {
// 	experiment: AMBROSIA_API_PREFIX + "/experiment",
// 	experimentStatic: AMBROSIA_API_PREFIX + "/experiment/static",
// 	userExperimentResult: AMBROSIA_API_PREFIX + "/user/experiment/result",
// 	userExperimentSummary: AMBROSIA_API_PREFIX + "/user/experiment/summary",
// 	userExperimentFilterCollection: AMBROSIA_API_PREFIX + "/user/experiment/filter/collection",
// 	userExperimentFilterAssigned: AMBROSIA_API_PREFIX + "/user/experiment/filter/assigned",
// 	userExperimentJoin: AMBROSIA_API_PREFIX + "/user/experiment/join",
// };

import ApiUtils from "../ApiUtils"
import { IAmbrosiaServiceApis } from "./IAmbrosiaServiceApis"
import { IMedicineSearchSuggestions } from "../../interfaces/patient/IMedication"
import { INutritionInsightsParams } from "../../interfaces/api/ambrosia/fetchNutritionInsights"
import { IGetMealPlanPdfUrlParams, IGetMealPlanPdfUrlResponse, IMealActivityLogRequestParams } from "../../interfaces/api/ambrosia/fetchMealActivityLogs"
import { AMBROSIA_API_PREFIX } from "../../../../server/src/configs/configs"
import { IFetchFitnessActivityLogParams, IFetchFitnessActivityLogRes } from "../../interfaces/api/ambrosia/fetchFitnessActivityLog"
import { IGetAllFitnessPlansParams, IGetAllFitnessPlansResponse } from "../../interfaces/api/ambrosia/getAllFitnessPlans"
import { ITopContributorRequestParams } from "../../interfaces/api/ambrosia/getTopContributorByDate"
import { IFetchActivityLogsByActivityTypeParams, IFetchActivityLogsByActivityTypeResponse } from "../../interfaces/api/ambrosia/fetchActivityLogByActivityType"
import { IFetchAllActivityLogsParams, IFetchAllActivityLogsRes } from "../../interfaces/api/ambrosia/fetchAllActivityLogs"
import {
	IGetUserFitnessAndMindfulnessLevelParams,
	IGetUserFitnessAndMindfulnessLevelResponse,
	IStartFitnessAndMindfullnessPlanParams,
	IStartFitnessAndMindfullnessPlanResponse,
} from "../../interfaces/api/ambrosia/IStartFitnessAndMindfulnessPlan"
import { IUserMealPlan, IUserMealPlanResponse } from "../../interfaces/api/ambrosia/IUserMealPlanResponse"
import { IUpdateUserPurchaseRecommendationsParams, IUserPurchaseRecommendationsResponse } from "../../interfaces/api/ambrosia/IPurchaseRecommendations"
import { IDish } from "../../interfaces/api/ambrosia/IMealOption"
import { IDietPlanTemplateSearchParams, IDietTemplate } from "../../interfaces/api/ambrosia/fetchUserMealPlan"
import { IMealItem, IMealItemWithDishDetail } from "../../interfaces/api/ambrosia/fetchMealDetailsByMealId"
import { IUserEnergyAllowanceResp } from "../../interfaces/api/ambrosia/fetchUserEnergyAllowance"
import { IFetchDietPlanReminderStatusParams, IFetchDietPlanReminderStatusRes } from "../../interfaces/api/ambrosia/fetchDietPlanReminderStatus"
import { IUpdateDietPlanReminderParams, IUpdateDietPlanReminderRes } from "../../interfaces/api/ambrosia/updateDietPlanReminder"
import { IStaticDataValue } from "../../interfaces/baseInterfaces"
import { getPatientTenant } from "../../utils/helpers"
import IDishCatalogueResponse, { IMultiDishCatalogueResponse } from "../../interfaces/api/maverick/IDishCatalogueResponse"
import { IReportDishValidationErrorParams, IReportDishValidationErrorResponse } from "../../interfaces/api/ambrosia/reportDishValidationError"
import { IDishRecmdReqParam } from "../../interfaces/api/ambrosia/fetchDishRecommendation"
import { IFetchLatestDietPlanRecommendationParams, IFetchLatestDietPlanRecommendationResponse } from "../../interfaces/api/ambrosia/fetchLatestDietPlanRecommendation"
import { IGenerateDietPlanRecommendationParams, IGenerateDietPlanRecommendationResponse } from "../../interfaces/api/ambrosia/generateDietPlanRecommendation"
import { IGetUserProgressSummaryParams, IGetUserProgressSummaryResponse } from "../../interfaces/api/sms/IRCA"
import {
	ICreateCustomMedicineParams,
	ICreateCustomMedicineResponse,
	IGetMedicinesParams,
	IGetMedicinesResponse,
	IPatchUpdateMedicineParams,
	IPatchUpdateMedicineResponse,
} from "../../interfaces/IMedicineCatalogue"
import { IGetMealPlanSuggestionEligibiltyPayload, IGetMealPlanSuggestionEligibiltyResponse } from "../../interfaces/api/ambrosia/getMealPlanSuggestionEligibility"
import { IAdd8pMealPlanSuggestionsPayload, IAdd8pMealPlanSuggestionsResponse } from "../../interfaces/api/ambrosia/add8pMealPlanSuggestions"
import { IGet8pMealPlanSuggestionsPayload, IGet8pMealPlanSuggestionsResponse } from "../../interfaces/api/ambrosia/get8pMealPlanSuggestions"
import { IBulkFetchDishDetailsPayload, IBulkFetchDishDetailsResponse } from "../../interfaces/api/ambrosia/bulkFetchDishDetails"
import { IApplyMealPlanSpecialProtocolPayload } from "../../interfaces/api/ambrosia/applyMealPlanSpecialProtocol"
import { IFetchHistoricalMealPlansForUserPayload, IFetchHistoricalMealPlansForUserResponse } from "../../interfaces/api/ambrosia/fetchHistoricalMealPlansForUser"
import { IFetchUserMealPlanByMealPlanIdPayload } from "../../interfaces/api/ambrosia/fetchUserMealPlanByMealPlanId"
import { IFetchUpcomingUserMealPlanPayload, IFetchUpcomingUserMealPlanResponse } from "../../interfaces/api/ambrosia/fetchUpcomingUserMealPlan"
import { IFetchUserExperimentResultPayload, IFetchUserExperimentResultResponse } from "../../interfaces/api/ambrosia/fetchUserExperimentResult"
import { IFetchUserExperimentSummaryPayload, IFetchUserExperimentSummaryResponse } from "../../interfaces/api/ambrosia/fetchUserExperimentSummary"
import { IFilterAssignedUserExperimentsPayload, IFilterAssignedUserExperimentsResponse } from "../../interfaces/api/ambrosia/filterAssignedUserExperiments"
import { IAddCustomMedicinePayload, IAddCustomMedicineResponse } from "../../interfaces/api/ambrosia/addCustomMedicine"
import { IFilterUserExperimentsCollectionPayload, IFilterUserExperimentsCollectionResponse } from "../../interfaces/api/ambrosia/filterUserExperimentsCollection"
import { IFetchExperimentDetailsPayload, IFetchExperimentDetailsResponse } from "../../interfaces/api/ambrosia/fetchExperimentDetails"
import { ICreateNewExperimentPayload, ICreateNewExperimentResponse } from "../../interfaces/api/ambrosia/createNewExperiment"
import { IJoinExperimentPayload, IJoinExperimentResponse } from "../../interfaces/api/ambrosia/joinExperiment"
import { IGenerateAiFitnessPlanPayload, IGenerateAIFitnessPlanResponse } from "../../interfaces/api/ambrosia/generateAiFitnessPlan"
import { IGetAiFitnessPlanByIdPayload } from "../../interfaces/api/ambrosia/getAiFitnessPlanById"
import { IBaseGetSearchPayload, IBaseGetSearchResponse } from "../../interfaces/api/common/baseGetSearch"

const AmbrosiaUrl = {
	medicineSearch: (query: string) => `/medicine/search?q=${encodeURIComponent(query)}`,
	getNutritionInsightsForDateRange: "/mealActivity/nutritionInsights",
	getMealActivityLogForDateRange: "/mealActivityLog/filter",
	getFitnessActivityLogForDateRange: "/fitnessActivityLog/filter",
	getAllFitnessPlans: (params: IGetAllFitnessPlansParams) => "/plan/all?" + ApiUtils.requestToQueryParams(params),
	getTopContributorByDate: (params: ITopContributorRequestParams) => "/mealActivity/topContribution?" + ApiUtils.requestToQueryParams(params),
	getActivityLogByActivityType: `/activityLog/filter`,
	fetchAllActivityLogs: "/activityLog/filterAll",
	startFitnessAndMindfulnessPlan: `/plan/start`,
	getFitnessAndMindfulnessLevel: `/plan/userLevel`,
	saveUserMealPlan: `/userMealPlan`,
	updateDietPlanNotification: `/dietNotification/update/notification`,
	updateUserPurchaseRecommendation: `/userPurchaseRecommendations/`,
	getUserPurchaseRecommendation: (userId: string): string => `/userPurchaseRecommendations/detailed?userId=${userId}`,
	staticCuisines: `/masterData/cuisines/nux`,
	searchDishByName: (q: string) => `/user/dish/search?q=${q}`,
	bulkDishSearch: `/dish/bulkFetch`,
	saveCustomDish: `/dish`,
	getMealPlan: (patientId: number) => `/userMealPlan/${patientId}`,
	fetchMealDetailsByMealId: (mealId: string) => `/meal/${mealId}/detail`,
	fetchUserEnenrgyAllowance: (patientId: number) => `/userMealPlan/TEE/${patientId}`,
	fetchDietPlanReminderStatus: (userId: string) => `/dietNotification/status?userId=${userId}`,
	updateDietPlanReminder: "/dietNotification/update/notification",
	createMeal: "/meal",
	triggerMealPlanPdf: (patientId: number, appTenant: string) => `/dailyUserMealPlan/send/pdf/whatsapp/${patientId}?appTenant=${appTenant}`,
	dietPlanTemplateSearch: "/mealTemplates/filter",
	getDietPlanTags: "/masterData/tags/getAll",
	fetchDishRecommendation: "/coach/dish/recommendation",
	getDishesByName: (queryString: string) => `/user/dish/search?q=${queryString}`,
	searchDishV2: (queryString: string, userId: number, epochTime: number) => `/user/dish/searchV2?q=${queryString}&userId=${userId}&epochTime=${epochTime}`,
	reportMealValidation: "/mealPlan/coachFeedback/bulk",
	generateDietPlanRecommendation: "/dietPlan/recommendation/generate/gpt",
	fetchLatestDietPlanRecommendation: ({ planGeneratedAfter, userId }: IFetchLatestDietPlanRecommendationParams) =>
		`/dietPlan/recommendation/latest?planGeneratedAfter=${planGeneratedAfter}&userId=${userId}`,
	getDishSignedUrl: (s3Key: string) => `/dish/signedGetURL?filename=${s3Key}`,
	getAiImageLoggedDishSignedUrl: (s3Key: string) => `/meal-prediction-log/signed-download-url?s3Key=${s3Key}`,
	deleteMealTemplate: (templateId: string) => `/mealTemplates/?id=${templateId}`,
	saveMealTemplate: `/mealTemplates`,
	userProgressSummary: `/user-progress/summary`,
	mealPlanPdf: `/v1/meal-plan-history/download-pdf`,
	getMedicines: `/medicine/filter`,
	getPatchMedicine: (id: string) => `/medicine/${id}`,
	createMedicine: `/medicine/custom`,
	get8pMealPlanSuggestions: "/userMealPlan/suggestions",
	add8pMealPlanSuggestions: "/userMealPlan/specialProtocol/suggestions",
	applyMealPlanSpecialProtocol: "/userMealPlan/specialProtocol",
	getMealPlanSuggestionEligibility: "/userMealPlan/suggestions/eligibility",
	bulkFetchDishDetails: "/dish/bulkFetch",
	fetchHistoricalMealPlansForUser: "/v1/meal-plan-history/all",
	fetchUserMealPlanByMealPlanId: "/userMealPlan",
	fetchUpcomingUserPlan: "/userMealPlan/dietPlan/upcoming",
	fetchUserExperimentsSummary: "/user/experiment/summary",
	filterAssignedUserExperiments: "/user/experiment/filter/assigned",
	fetchUserExperimentResult: "/user/experiment/result",
	addCustomMedicine: "/user/medicine/custom",
	filterUserExperimentCollection: "/user/experiment/filter/collection",
	fetchExperimentDetails: "/experiment",
	createExperiment: "/experiment",
	joinExperiment: "/user/experiment/join",
	getAllExperimentLevels: "/experiment/levels",
	generateAiFitnessPlan: "/aiFitnessPlan/generate",
	searchAiFitnessPlan: "/aiFitnessPlan/search",
	getAiFitnessPlanById: (id: string) => `/aiFitnessPlan/${id}`
}

export default class AmbrosiaServiceApis implements IAmbrosiaServiceApis {
	getServiceUrl = (url: string) => AMBROSIA_API_PREFIX + url
	getDietTemplateTags(): Promise<{ name: string }[]> {
		const url = this.getServiceUrl(AmbrosiaUrl.getDietPlanTags)
		return ApiUtils.get(url)
	}

	fetchDietPlanTemplates(params: IDietPlanTemplateSearchParams): Promise<IDietTemplate[]> {
		const url = this.getServiceUrl(AmbrosiaUrl.dietPlanTemplateSearch)
		return ApiUtils.post(url, params)
	}

	saveMealTemplate(mealTemplate: IDietTemplate): Promise<IDietTemplate> {
		return ApiUtils.post(this.getServiceUrl(AmbrosiaUrl.saveMealTemplate), mealTemplate)
	}

	saveUserMealPlan(mealPlan: IUserMealPlan): Promise<IUserMealPlanResponse> {
		return ApiUtils.post(this.getServiceUrl(AmbrosiaUrl.saveUserMealPlan), mealPlan)
	}

	deleteMealTemplate(templateId: string): Promise<any> {
		return ApiUtils.delete(this.getServiceUrl(AmbrosiaUrl.deleteMealTemplate(templateId)), {})
	}

	updateMealTemplate(mealTemplate: IDietTemplate): Promise<any> {
		return ApiUtils.patch(this.getServiceUrl(AmbrosiaUrl.saveMealTemplate), mealTemplate)
	}

	createMeal(meal: IMealItem): Promise<IMealItem> {
		const url = this.getServiceUrl(AmbrosiaUrl.createMeal)
		return ApiUtils.post(url, meal)
	}

	// fetchMealByMealId(mealId: string): Promise<IMealItem> {
	// 	return ApiUtils.apiGetRequest(GET_MEAL_BY_MEAL_ID_URL.replace("$mealId", mealId));
	// }

	fetchUserMealPlan(patientId: number): Promise<IUserMealPlanResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.getMealPlan(patientId))
		return ApiUtils.get(url)
	}

	getDishByDishName(input: string): Promise<IDishCatalogueResponse[]> {
		const url = this.getServiceUrl(AmbrosiaUrl.getDishesByName(encodeURIComponent(input)))
		return ApiUtils.get(url)
	}

	searchDishV2(input: string, userId: number): Promise<IMultiDishCatalogueResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.searchDishV2(encodeURIComponent(input), userId, Date.now()))
		return ApiUtils.get(url)
	}

	// fetchDishByDishId(dishId: string): Promise<IMealItem> {
	// 	return ApiUtils.apiPostRequest(GET_DISH_BY_DISH_IDS_URL, JSON.stringify({ dishIds: [dishId] }));
	// }
	//
	fetchDishesByDishIds(dishIds: string[]): Promise<IDish[]> {
		return ApiUtils.post(this.getServiceUrl(AmbrosiaUrl.bulkDishSearch), { dishIds })
	}
	//
	// saveCustomMedicine(params: any): Promise<any> {
	// 	return ApiUtils.apiPostRequest(LOG_CUSTOM_MEDICINE_URL, JSON.stringify({ ...params }));
	// }
	//
	saveCustomDish(params: any): Promise<any> {
		return ApiUtils.post(this.getServiceUrl(AmbrosiaUrl.saveCustomDish), { ...params })
	}
	//
	searchMedicine(query: string): Promise<IMedicineSearchSuggestions[]> {
		return ApiUtils.get(this.getServiceUrl(AmbrosiaUrl.medicineSearch(query)))
	}

	fetchMealDetailsByMealId(mealId: string): Promise<IMealItemWithDishDetail> {
		const url = this.getServiceUrl(AmbrosiaUrl.fetchMealDetailsByMealId(mealId))
		return ApiUtils.get(url)
	}

	// fetchDishNutritionProfile(dish: IDishNutritionProfileReq[]): Promise<IDishNutritionProfileResp> {
	// 	return ApiUtils.apiPostRequest(GET_DISH_NUTRITION_PROFILE_URL, JSON.stringify(dish));
	// }

	fetchDishRecommendation(reqParam: IDishRecmdReqParam): Promise<IDish[]> {
		const url = this.getServiceUrl(AmbrosiaUrl.fetchDishRecommendation)
		return ApiUtils.post(url, reqParam)
	}

	fetchUserEnergyAllowance(patientId: number): Promise<IUserEnergyAllowanceResp> {
		const url = this.getServiceUrl(AmbrosiaUrl.fetchUserEnenrgyAllowance(patientId))
		return ApiUtils.get(url)
	}

	// getExperimentsStaticData(): Promise<ExperimentsStaticData> {
	// 	return ApiUtils.apiGetRequest(experimentsUrl.experimentStatic);
	// }
	//
	// createExperiment(payload: CreateExperimentRequest): Promise<Experiment> {
	// 	return ApiUtils.apiPostRequest(experimentsUrl.experiment, JSON.stringify(payload));
	// }
	//
	// joinExperiment(userId: number, experimentId: number): Promise<UserExperimentJoinResponse> {
	// 	const payload = { userId, experimentId };
	// 	return ApiUtils.apiPostRequest(experimentsUrl.userExperimentJoin, JSON.stringify(payload));
	// }
	//
	// getExperimentDetail(experimentId: number): Promise<Experiment> {
	// 	const querystring = stringify({ experimentId });
	// 	return ApiUtils.apiGetRequest(`${experimentsUrl.experiment}?${querystring}`);
	// }
	//
	// getUserExperimentResult(userId: number, userExperimentId: number): Promise<UserExperimentResult> {
	// 	const querystring = stringify({ userId, userExperimentId });
	// 	return ApiUtils.apiGetRequest(`${experimentsUrl.userExperimentResult}?${querystring}`);
	// }
	//
	// getUserExperimentsSummary(userId: number): Promise<UserExperimentsSummary> {
	// 	const querystring = stringify({ userId });
	// 	return ApiUtils.apiGetRequest(`${experimentsUrl.userExperimentSummary}?${querystring}`);
	// }
	//
	// filterUserExperimentsCollection(userId: number, categories?: ExperimentCategories[], limit: number = 100, offset: number = 0): Promise<UserExperimentCollectionResponse> {
	// 	const payload = {
	// 		categories,
	// 		limit,
	// 		offset,
	// 		userId,
	// 	};
	// 	return ApiUtils.apiPostRequest(experimentsUrl.userExperimentFilterCollection, JSON.stringify(payload));
	// }
	//
	// filterUserExperimentsAssigned(userId: number, type: UserAssignedExperimentType): Promise<UserExperimentAssignedResponse> {
	// 	const payload = { userId, type };
	// 	return ApiUtils.apiPostRequest(experimentsUrl.userExperimentFilterAssigned, JSON.stringify(payload));
	// }
	//
	// fetchPatientActivityLogging(param: ICgmActivitiesSearchParams): Promise<IPatientActivityImpactItem[]> {
	// 	return ApiUtils.apiPostRequest(GET_PATIENT_ACTIVITY_LOGGING_URL, JSON.stringify(param));
	// }
	//
	fetchMealActivityLog(params: IMealActivityLogRequestParams): Promise<any> {
		return ApiUtils.post(this.getServiceUrl(AmbrosiaUrl.getMealActivityLogForDateRange), params)
	}

	fetchNutritionInsights(params: INutritionInsightsParams): Promise<any> {
		return ApiUtils.post(this.getServiceUrl(AmbrosiaUrl.getNutritionInsightsForDateRange), params)
	}

	fetchTopContributorByDate(params: ITopContributorRequestParams): Promise<any> {
		const url = this.getServiceUrl(AmbrosiaUrl.getTopContributorByDate(params))
		return ApiUtils.get(url)
	}

	fetchAllActivityLogs(params: IFetchAllActivityLogsParams): Promise<IFetchAllActivityLogsRes> {
		const url = this.getServiceUrl(AmbrosiaUrl.fetchAllActivityLogs)
		return ApiUtils.post(url, params)
	}
	fetchDietPlanReminderStatus(params: IFetchDietPlanReminderStatusParams): Promise<IFetchDietPlanReminderStatusRes[]> {
		const { userId } = params
		const url = this.getServiceUrl(AmbrosiaUrl.fetchDietPlanReminderStatus(userId))
		return ApiUtils.get(url)
	}

	updateDietPlanReminder(params: IUpdateDietPlanReminderParams): Promise<IUpdateDietPlanReminderRes> {
		const url = this.getServiceUrl(AmbrosiaUrl.updateDietPlanReminder)
		return ApiUtils.post(url, params)
	}

	fetchFitnessActivityLogForFilter(params: IFetchFitnessActivityLogParams): Promise<IFetchFitnessActivityLogRes> {
		return ApiUtils.post(this.getServiceUrl(AmbrosiaUrl.getFitnessActivityLogForDateRange), params)
	}

	fetchStaticCuisines(): Promise<IStaticDataValue[]> {
		return ApiUtils.get(this.getServiceUrl(AmbrosiaUrl.staticCuisines))
	}

	updateUserPurchaseRecommendations(params: IUpdateUserPurchaseRecommendationsParams): Promise<IUserPurchaseRecommendationsResponse> {
		return ApiUtils.post(this.getServiceUrl(AmbrosiaUrl.updateUserPurchaseRecommendation), params)
	}

	getUserPurchaseRecommendations(userId: string): Promise<IUserPurchaseRecommendationsResponse> {
		return ApiUtils.get(this.getServiceUrl(AmbrosiaUrl.getUserPurchaseRecommendation(userId)))
	}

	triggerMealPlanPdf(patientId: number): Promise<any> {
		const url = this.getServiceUrl(AmbrosiaUrl.triggerMealPlanPdf(patientId, getPatientTenant()))
		return ApiUtils.get(url)
	}

	// updateUserPurchaseRecommendations(params: IUpdateUserPurchaseRecommendationsParams): Promise<IUserPurchaseRecommendationsResponse> {
	// 	return ApiUtils.apiPostRequest(UPDATE_USER_PURCHASE_RECOMMENDATIONS, JSON.stringify(params));
	// }
	//
	// getUserPurchaseRecommendations(userId: string): Promise<IUserPurchaseRecommendationsResponse> {
	// 	const url = getUserPurchaseRecommendationsUrl(userId);
	// 	return ApiUtils.apiGetRequest(url);
	// }
	//
	getAllFitnessPlans(params: IGetAllFitnessPlansParams): Promise<IGetAllFitnessPlansResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.getAllFitnessPlans(params))
		return ApiUtils.get(url)
	}
	//
	startFitnessAndMindfulnessPlan(params: IStartFitnessAndMindfullnessPlanParams): Promise<IStartFitnessAndMindfullnessPlanResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.startFitnessAndMindfulnessPlan) + "?" + ApiUtils.requestToQueryParams(params)
		return ApiUtils.post(url, {})
	}

	getUserFitnessAndMindfulnessLevel(params: IGetUserFitnessAndMindfulnessLevelParams): Promise<IGetUserFitnessAndMindfulnessLevelResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.getFitnessAndMindfulnessLevel) + "?" + ApiUtils.requestToQueryParams(params)
		return ApiUtils.get(url)
	}
	//
	getUserProgressSummary(params: IGetUserProgressSummaryParams): Promise<IGetUserProgressSummaryResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.userProgressSummary + "?" + ApiUtils.requestToQueryParams(params))
		return ApiUtils.get(url)
	}
	getActivityLogByActivityType(params: IFetchActivityLogsByActivityTypeParams): Promise<IFetchActivityLogsByActivityTypeResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.getActivityLogByActivityType)
		return ApiUtils.post(url, params)
	}

	reportDishValidationError(params: IReportDishValidationErrorParams[]): Promise<IReportDishValidationErrorResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.reportMealValidation)
		return ApiUtils.post(url, params)
	}

	generateDietPlanRecommendation(params: IGenerateDietPlanRecommendationParams): Promise<IGenerateDietPlanRecommendationResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.generateDietPlanRecommendation)
		return ApiUtils.post(url, params)
	}

	fetchLatestDietPlanRecommendation(params: IFetchLatestDietPlanRecommendationParams): Promise<IFetchLatestDietPlanRecommendationResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.fetchLatestDietPlanRecommendation(params))
		return ApiUtils.get(url, params)
	}

	getImageLoggedDishSignedUrl(s3Key: string): Promise<Record<string, string>> {
		const url = this.getServiceUrl(AmbrosiaUrl.getDishSignedUrl(s3Key))
		return ApiUtils.get(url)
	}

	getAiImageLoggedDishSignedUrl(s3Key: string): Promise<Record<string, string>> {
		const url = this.getServiceUrl(AmbrosiaUrl.getAiImageLoggedDishSignedUrl(s3Key))
		return ApiUtils.get(url)
	}

	getMealPlanPdfUrl(params: IGetMealPlanPdfUrlParams): Promise<IGetMealPlanPdfUrlResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.mealPlanPdf) + "?" + ApiUtils.requestToQueryParams(params)
		return ApiUtils.get(url)
	}

	getMedicines(params: IGetMedicinesParams): Promise<IGetMedicinesResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.getMedicines) + "?" + ApiUtils.requestToQueryParams(params)
		return ApiUtils.get(url)
	}

	patchUpdateMedicine(params: IPatchUpdateMedicineParams): Promise<IPatchUpdateMedicineResponse> {
		const { id, ...restPayload } = params
		const url = this.getServiceUrl(AmbrosiaUrl.getPatchMedicine(params.id))
		return ApiUtils.patch(url, restPayload)
	}

	createCustomMedicine(params: ICreateCustomMedicineParams): Promise<ICreateCustomMedicineResponse> {
		return ApiUtils.post(this.getServiceUrl(AmbrosiaUrl.createMedicine), params, {
			X_USER_ID: params.userId,
		})
	}

	getMealPlanSuggestionsEligiblity(params: IGetMealPlanSuggestionEligibiltyPayload): Promise<IGetMealPlanSuggestionEligibiltyResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.getMealPlanSuggestionEligibility) + "?" + ApiUtils.requestToQueryParams(params)
		return ApiUtils.get(url)
	}

	add8pMealPlanSuggestions(params: IAdd8pMealPlanSuggestionsPayload): Promise<IAdd8pMealPlanSuggestionsResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.add8pMealPlanSuggestions)
		return ApiUtils.post(url, params)
	}

	get8pMealPlanSuggestions(params: IGet8pMealPlanSuggestionsPayload): Promise<IGet8pMealPlanSuggestionsResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.get8pMealPlanSuggestions) + "?" + ApiUtils.requestToQueryParams(params)
		return ApiUtils.get(url)
	}

	applyMealPlanSpecialProtocol(params: IApplyMealPlanSpecialProtocolPayload): Promise<IUserMealPlan> {
		const url = this.getServiceUrl(AmbrosiaUrl.applyMealPlanSpecialProtocol)
		return ApiUtils.post(url, params)
	}

	fetchHistoricalMealPlanForUser(params: IFetchHistoricalMealPlansForUserPayload): Promise<IFetchHistoricalMealPlansForUserResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.fetchHistoricalMealPlansForUser) + "?" + ApiUtils.requestToQueryParams(params)
		return ApiUtils.get(url)
	}

	fetchUserMealPlanByMealPlanId(params: IFetchUserMealPlanByMealPlanIdPayload): Promise<IUserMealPlan> {
		const url = this.getServiceUrl(AmbrosiaUrl.fetchUserMealPlanByMealPlanId + "?" + ApiUtils.requestToQueryParams(params))
		return ApiUtils.get(url)
	}

	fetchUpcomingUserMealPlan(params: IFetchUpcomingUserMealPlanPayload): Promise<IFetchUpcomingUserMealPlanResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.fetchUpcomingUserPlan) + "?" + ApiUtils.requestToQueryParams(params)
		return ApiUtils.get(url)
	}

	bulkFetchDishDetails(params: IBulkFetchDishDetailsPayload): Promise<IBulkFetchDishDetailsResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.bulkFetchDishDetails)
		return ApiUtils.post(url, params)
	}

	fetchUserExperimentResult(payload: IFetchUserExperimentResultPayload, headers?: any): Promise<IFetchUserExperimentResultResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.fetchUserExperimentResult) + "?" + ApiUtils.requestToQueryParams(payload)
		return ApiUtils.get(url, headers)
	}

	fetchUserExperimentSummary(payload: IFetchUserExperimentSummaryPayload, headers?: any): Promise<IFetchUserExperimentSummaryResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.fetchUserExperimentsSummary) + "?" + ApiUtils.requestToQueryParams(payload)
		return ApiUtils.get(url, headers)
	}

	filterAssignedUserExperiments(payload: IFilterAssignedUserExperimentsPayload, headers?: any): Promise<IFilterAssignedUserExperimentsResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.filterAssignedUserExperiments)
		return ApiUtils.post(url, payload, headers)
	}

	addCustomMedicine(payload: IAddCustomMedicinePayload): Promise<IAddCustomMedicineResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.addCustomMedicine);
		return ApiUtils.post(url, payload)
	}

	filterUserExperimentCollection(payload: IFilterUserExperimentsCollectionPayload, headers?: any): Promise<IFilterUserExperimentsCollectionResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.filterUserExperimentCollection)
		return ApiUtils.post(url, payload, headers)
	}

	fetchExperimentDetails(payload: IFetchExperimentDetailsPayload, header?: any): Promise<IFetchExperimentDetailsResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.fetchExperimentDetails) + "?" + ApiUtils.requestToQueryParams(payload);
		return ApiUtils.get(url, header);
	}

	createNewExperiment(payload: ICreateNewExperimentPayload, header?: any): Promise<ICreateNewExperimentResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.createExperiment);
		return ApiUtils.post(url, payload, header);
	}

	joinExperiment(payload: IJoinExperimentPayload, header?: any): Promise<IJoinExperimentResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.joinExperiment);
		return ApiUtils.post(url, payload, header);
	}

	getAllExperimentLevels(): Promise<string[]> {
		const url = this.getServiceUrl(AmbrosiaUrl.getAllExperimentLevels);
		return ApiUtils.get(url);
	}

	generateAiFitnessPlan(payload: IGenerateAiFitnessPlanPayload): Promise<IGenerateAIFitnessPlanResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.generateAiFitnessPlan);
		return ApiUtils.post(url, payload);
	}

	getAiFitnessPlanById(payload: IGetAiFitnessPlanByIdPayload): Promise<IGenerateAIFitnessPlanResponse> {
		const url = this.getServiceUrl(AmbrosiaUrl.getAiFitnessPlanById(payload.id)); 
		return ApiUtils.get(url);
	}


	searchAiFitnessPlan(payload: IBaseGetSearchPayload): Promise<IBaseGetSearchResponse<IGenerateAIFitnessPlanResponse>> {
		const query = payload.query || "";
		delete payload["query"];
		const url = this.getServiceUrl(AmbrosiaUrl.searchAiFitnessPlan) + "?" + ApiUtils.requestToQueryParams(payload) + "&query=" + query;
		return ApiUtils.get(url);
	}
}
